import { useDispatch } from "react-redux";
import { useSetThemeMutation } from "../api/accountSlice/accountSlice";
import { setUserDataTheme } from "../store/login.slice";

/*
 * Saves the user's theme ("default" | "dark" | "ocean") and applies it app-wide.
 * Shared by Account Settings and the test page settings bar so both behave
 * the same: the store is only updated once the backend has saved it.
 * Throws the RTK Query error if saving fails, so callers can react to it.
 */
export default function useSetUserTheme() {
  const dispatch = useDispatch();
  const [setTheme, { isLoading }] = useSetThemeMutation();

  const applyTheme = async (theme: string) => {
    const result = await setTheme({ theme }).unwrap();
    dispatch(setUserDataTheme({ theme }));
    return result;
  };

  return { applyTheme, isSavingTheme: isLoading };
}
